import { Controller } from '@hotwired/stimulus';
import ApexCharts from 'apexcharts';

export default class extends Controller {
  static targets = ['scanChart', 'deviceChart', 'countryChart'];
  static values = {
    dailyData: Array,
    deviceData: Object,
    countryData: Object,
  };

  connect() {
    this.renderCharts();
  }

  renderCharts() {
    this.renderTimeSeriesChart();
    this.renderDeviceChart();
    this.renderCountryChart();
  }

  renderTimeSeriesChart() {
    if (!this.hasScanChartTarget) return;

    const dates = this.dailyDataValue.map((item) => item.date);
    const counts = this.dailyDataValue.map((item) => item.count);

    const scanChartOptions = {
      series: [
        {
          name: 'Scans',
          data: counts,
        },
      ],
      chart: {
        type: 'area',
        height: 250,
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      xaxis: {
        categories: dates,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + ' scans';
          },
        },
      },
    };

    const scanChart = new ApexCharts(this.scanChartTarget, scanChartOptions);
    scanChart.render();
  }

  renderDeviceChart() {
    if (!this.hasDeviceChartTarget) return;

    const deviceLabels = Object.keys(this.deviceDataValue);
    const deviceValues = Object.values(this.deviceDataValue);

    const deviceChartOptions = {
      series: deviceValues,
      chart: {
        type: 'donut',
        height: 250,
      },
      labels: deviceLabels,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    };

    const deviceChart = new ApexCharts(
      this.deviceChartTarget,
      deviceChartOptions
    );
    deviceChart.render();
  }

  renderCountryChart() {
    if (!this.hasCountryChartTarget) return;

    const countryLabels = Object.keys(this.countryDataValue);
    const countryValues = Object.values(this.countryDataValue);

    const countryChartOptions = {
      series: countryValues,
      chart: {
        type: 'donut',
        height: 250,
      },
      labels: countryLabels,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    };

    const countryChart = new ApexCharts(
      this.countryChartTarget,
      countryChartOptions
    );
    countryChart.render();
  }
}
